import { render, staticRenderFns } from "./ProviderArchived.vue?vue&type=template&id=4e734d03&scoped=true"
import script from "./ProviderArchived.vue?vue&type=script&lang=js"
export * from "./ProviderArchived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e734d03",
  null
  
)

export default component.exports